import { groupBy, mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ComponentDesign } from '@paragon/contract-library';

import { AssemblyMemberPart, getAssemblyMemberParts } from './assemblyPartsUtilities';
import { getComponentInventoryStockLengths } from './getComponentInventoryStockLengths';
import { getProductionAnalysisSetComponentDesignByAnalysisSetGuid } from './getProductionAnalysisSetComponentDesignByAnalysisSetGuid';
import { getOrderedProductionComponentInstancesForActiveScheduleLineGroup } from './scheduleStationSelectors';

export const getAssemblyMemberPartsForActiveScheduleLineGroup = createSelector(
  getOrderedProductionComponentInstancesForActiveScheduleLineGroup,
  getProductionAnalysisSetComponentDesignByAnalysisSetGuid,
  getComponentInventoryStockLengths,

  (
    instancesForActiveScheduleLineGroup,
    productionAnalysisSetComponentDesignByAnalysisSetGuid,
    stockLengths,
  ): readonly AssemblyMemberPart[] => {
    const analysisSetGuidQuantities = mapValues(
      groupBy(instancesForActiveScheduleLineGroup, ({ analysisSetGuid }) => analysisSetGuid),
      (instances) => instances.length,
    );
    const uniqueAnalysisSetGuids = Object.keys(analysisSetGuidQuantities);
    const analysisSetGuidToComponentDesign = uniqueAnalysisSetGuids.reduce(
      (accumulator, analysisSetGuid) => {
        if (analysisSetGuid in productionAnalysisSetComponentDesignByAnalysisSetGuid)
          accumulator[analysisSetGuid] = productionAnalysisSetComponentDesignByAnalysisSetGuid[analysisSetGuid];
        return accumulator;
      },
      {} as { [analysisSetGuid: string]: ComponentDesign },
    );

    return getAssemblyMemberParts(analysisSetGuidQuantities, analysisSetGuidToComponentDesign, stockLengths, 'desc');
  },
);
